import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const RETURN_URL = `${environment.frontUrl}practice/practice-info`;

@Injectable({ providedIn: 'root' })
export class StripeService {

    readonly stripeKey = environment.stripeKey;

    constructor(public _http: HttpClient) {}

    getCustomerPortalSession() {
        return this._http.get(`${environment.apiUrl}/user/customer-portal`);
    }
}
